import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

// Rótulos e cores por status da consulta, usados na lista de consultas do paciente.
const STATUS_CONFIG = {
  SCHEDULED: { label: 'Agendada', color: 'info' },
  CONFIRMED: { label: 'Confirmada', color: 'primary' },
  CONFIRMED_BY_PATIENT: { label: 'Confirmada pelo paciente', color: 'primary' },
  PERFORMED: { label: 'Realizada', color: 'success' },
  NO_SHOW: { label: 'Não compareceu', color: 'default' },
  CANCELED: { label: 'Cancelada', color: 'error' },
};

export const formatText = (value) => (value ? value : '-');

export const getStatusLabel = (appointment) =>
  appointment.statusDescription ?? STATUS_CONFIG[appointment.status]?.label ?? '-';

export const getStatusColor = (appointment) =>
  STATUS_CONFIG[appointment.status]?.color ?? 'default';

export const formatDuration = (appointment) =>
  appointment.duration ? `${appointment.duration} min` : '-';

export const formatDateAndTime = (appointment) =>
  [appointment.date, appointment.time].filter(Boolean).join(' às ') || '-';

// Ordena as consultas da mais recente para a mais antiga.
// As datas trafegam como DD/MM/YYYY e as horas como HH:mm.
export const sortByDateDesc = (appointments) =>
  [...appointments].sort((first, second) => {
    const firstDate = dayjs(`${first.date} ${first.time ?? ''}`.trim(), [
      'DD/MM/YYYY HH:mm',
      'DD/MM/YYYY',
    ]);
    const secondDate = dayjs(`${second.date} ${second.time ?? ''}`.trim(), [
      'DD/MM/YYYY HH:mm',
      'DD/MM/YYYY',
    ]);
    if (!firstDate.isValid() || !secondDate.isValid()) return 0;
    return secondDate.valueOf() - firstDate.valueOf();
  });
